const icon = require('vue-svgicon');
icon.register({
    'wallet': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" clip-rule="evenodd" d="M16.11 18.889h1.112c.614 0 1.111-.498 1.111-1.111V6.667c0-.614-.497-1.111-1.111-1.111V2.222c0-.613-.497-1.11-1.111-1.11L2.778 5.555c-.614 0-1.111.497-1.111 1.11v11.112c0 .613.497 1.11 1.11 1.11h13.334zm-.555-16.667c.307 0 .556.249.556.556v2.778H6.389l9.166-3.334zm1.667 10H15v1.111h2.222v-1.11zm-3.333 2.222h3.333v2.778a.555.555 0 01-.555.556H3.333a.555.555 0 01-.555-.556v-10c0-.307.248-.555.555-.555h13.334c.306 0 .555.248.555.555v3.89h-3.333v3.332z"/>`,
    },
});
